module.exports = __webpack_public_path__ + "img/sad-face-icon.c65cd880.svg";